import React, { useEffect, useState, useRef } from "react";
import { Input, Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import styles from "./PartsLis.module.css";
import "../../../src/assets/styles/local/PartListModalPopup.css";
import {
  FetchSuppliers,
  updateSelectedPart,
  DeleteAssetBillOfMaterial,
  removeSelectedPart,
} from "../../redux/actions/action";
import Modal from "react-bootstrap/Modal";

import closeIcon from "../../assets/icons/x-circle.svg";
import deleteIcon from "../../assets/icons/DeleteIcon.svg";
import stockAuto from "../../assets/icons/package.svg";
import tool from "../../assets/icons/tool.svg";
import aperture from "../../assets/icons/aperture.svg";
import Show from "../../assets/icons/Notshow.svg";
import Doc from "../../assets/icons/Document_2.svg";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import CurrencyInput from "react-currency-input";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

function PartsList({ groupList, fetchGroupList, props }) {
  const dispatch = useDispatch();
  const supplierPopupRef = useRef(null);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Assets-Add").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const selectedParts = useSelector((state) => state.user.selectedParts);
  // const [materialName, setMaterialName] = useState("");
  // const [min, setMin] = useState("");
  // const [supplier, setSupplier] = useState("");
  const [stockReorderData, setStockReorderData] = useState([
    {
      materialName: "",
      min: "",
      supplier: "",
    },
  ]);

  const [canbanPopup, setCanbanPopup] = useState(false);
  const [reorderPopup, setReorderPopup] = useState(false);
  const [ascpartName, setAscpartName] = useState("");
  const [ascpartId, setAscpartId] = useState("");
  const [supplierData, setSupplierData] = useState([]);
  const [supplierDataShow, setSupplierDataShow] = useState(false);

  const fetchSuppliersProductList = useSelector(
    (state) => state.user.fetchSuppliersProduct
  );

  const deleteBOMitemRes = useSelector((state) => state.user.deleteBOMitemRes);

  useEffect(() => {
    // dispatch(FetchSuppliers()); do not open it.
  }, [dispatch]);

  useEffect(() => {
    if (fetchSuppliersProductList.status === true) {
      setSupplierData(fetchSuppliersProductList?.data);
    }
  }, [fetchSuppliersProductList]);

  const hanldeInputChange = (value, key, record) => {
    record[key] = value;
    record.totalCost = (record.quantity || 0) * (record.unitCost || 0);
    dispatch(updateSelectedPart(record));
  };

  useEffect(() => {}, [selectedParts]);

  const tableRowColumns = [
    {
      // title: "Part",
      title: t("Part"),
      dataIndex: "name",
      key: "name",
      render: (text, record) => text,
    },
    {
      // title: "Qty",
      title: t("Qty"),
      dataIndex: "quantity",
      key: "quantity",
      render: (text, record) => (
        <Input
          variant="borderless"
          value={text}
          type="number"
          onChange={(e) =>
            hanldeInputChange(e.target.value, "quantity", record)
          }
        />
      ),
    },
    {
      // title: "Unit Cost",
      title: t("Unit Cost"),
      dataIndex: "unitCost",
      key: "unitCost",
      render: (text, record) => (
        // <Input
        //   variant="borderless"
        //   value={text}
        //   type="number"
        //   onChange={(e) =>
        //     hanldeInputChange(e.target.value, "unitCost", record)
        //   }
        // />

        <CurrencyInput
          className=""
          style={{ border: "none" }}
          placeholder="€ 0,00"
          name="salepriceexcvat"
          value={text}
          onChangeEvent={(e, maskedvalue, floatvalue) => {
            // let updateObject = {
            //   name: "salepriceexcvat",
            //   value: floatvalue,
            // };
            // hanldeInputChange(e.target.value, "unitCost", record);
            // taking floatvalue instaed of e.target.value👇
            hanldeInputChange(floatvalue, "unitCost", record);
          }}
          decimalSeparator=","
          thousandSeparator="."
          precision="2"
          allowEmpty={true}
          allowNegative
          prefix="€ "
        />
      ),
    },
    {
      // title: "Total Cost",
      title: t("Total Cost"),
      dataIndex: "totalCost",
      key: "totalCost",
      render: (text, record) => europeanFormatWithSymbol(text),
    },
    {
      title: "",
      dataIndex: "",
      key: "",
      render: (text, record) => (
        <AscComponent
          partId={record.partId}
          record={record}
          setAscpartName={setAscpartName}
          setAscpartId={setAscpartId}
        />
      ),
    },
  ];

  const AscComponent = ({ partId, record, setAscpartName, setAscpartId }) => {
    return (
      <div className="pointer" style={{ position: "relative" }}>
        <h2
          style={{ rotate: "90deg", textAlign: "center" }}
          onClick={() => {
            setCanbanPopup(!canbanPopup);
            setAscpartName(record.name);
            setAscpartId(partId);
          }}
        >
          ...
        </h2>
        {canbanPopup && ascpartId === partId && (
          <div className={`${styles.canbanPop} p-3 h-auto`}>
            <div
              className={`${styles.canbanPopText} `}
              onClick={() => {
                setReorderPopup(true);
                setCanbanPopup(false);
              }}
            >
              <img className={styles.canbanIcon} src={stockAuto} alt="" />
              <p> Stock Auto-reorder</p>
            </div>
            <div
              className={`${styles.canbanPopText} d-none`}
              onClick={() => {
                "asc";
              }}
            >
              <img className={styles.canbanIcon} src={tool} alt="" />
              <p> Create Maintenance</p>
            </div>
            <div
              className={`${styles.canbanPopText} d-none`}
              onClick={() => {
                "asc";
              }}
            >
              <img className={styles.canbanIcon} src={Doc} alt="" />
              <p> Create PO</p>
            </div>
            <div
              className={`${styles.canbanPopText} d-none`}
              onClick={() => {
                "asc";
              }}
            >
              <img className={styles.canbanIcon} src={aperture} alt="" />
              <p>Assembly Instructions</p>
            </div>
            <div
              className={`${styles.canbanPopText} `}
              onClick={() => {
                if (
                  record.bomId &&
                  record.bomId !== "00000000-0000-0000-0000-000000000000"
                ) {
                  // backend api run to delete
                  dispatch(DeleteAssetBillOfMaterial(record.bomId));
                } else {
                  // local api run to delete
                  dispatch(removeSelectedPart(record.partId));
                }
              }}
            >
              <img className={styles.canbanIcon} src={deleteIcon} alt="" />
              <p>Delete</p>
            </div>
          </div>
        )}
      </div>
    );
  };

  const handleOnChange = (index, key, value) => {
    // here value = e.target.value
    // and key = like => list[index]["supplier"]

    let list = [...stockReorderData];
    list[index][key] = value;
    let mate_length = list[index]["materialName"].length;
    let min_length = list[index]["min"].length;
    let supp_length = list[index]["supplier"].length;

    if (mate_length > 0 && min_length > 0 && supp_length > 0) {
      // let obj = list[index + 1];
      let obj = list[index + 0];
      if (!obj) {
        list.push({
          materialName: "",
          min: "",
          supplier: "",
        });
      }
    }
    setStockReorderData([...list]);
  };

  // ASC close dropDown dlick dutside start
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        supplierPopupRef.current &&
        !supplierPopupRef.current.contains(e.target)
      ) {
        setSupplierDataShow(false);
        // setArrowOptionsRotate(false);
      }
      // if (
      //   creditPopupRef.current &&
      //   !creditPopupRef.current.contains(e.target)
      // ) {
      //   setCreditSerialShow(false);
      // }
    };

    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);
  // ASC close dropDown dlick dutside end

  // Inject ascpartName into materialName if empty (only once)
  useEffect(() => {
    if (ascpartName?.trim()) {
      setStockReorderData((prevList) => {
        const updatedList = [...prevList];
        if (updatedList[0]) {
          updatedList[0].materialName = ascpartName;
        }
        return updatedList;
      });
    }
  }, [ascpartName]);

  return (
    <>
      <div className={`partlist-table-wrapper ${styles.partlist_table_wrap}`}>
        <div className={`${styles.table_wrapper} part-table`}>
          {selectedParts && (
            <Table
              columns={tableRowColumns}
              // dataSource={selectedParts}
              dataSource={[
                ...new Map(
                  selectedParts.map((part) => [part.partId, part])
                ).values(),
              ]}
            />
          )}
        </div>
      </div>

      <popupSection>
        <div className={`${styles.reorderPop} `}>
          <Modal
            {...props}
            size="lg"
            show={reorderPopup}
            onHide={() => setReorderPopup(false)}
            backdrop="static"
            keyboard={false}
            id="asc_project_PartList"
            dialogClassName="custum_projectPop"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton></Modal.Header>
            <div className="ps-3">
              <p className="fw-bold mb-0">Stock Auto-reorder</p>
              <p className="">
                Make a Purchasing Order when the stock level reaches the Min
              </p>

              {stockReorderData.map((item, index) => {
                return (
                  <div className="d-flex gap-3">
                    <div className="asc-input-container mt-3" id="ascInput">
                      <label className="asc-label-top ClientNameText">
                        Material Name
                      </label>
                      <input
                        type="text"
                        // disabled
                        // readOnly
                        className="asc_NormalInput ps-4 pointerEven-t"
                        style={{
                          width: "310px",
                          color: "#323232",
                          fontWeight: "600",
                          pointerEvents: "none",
                        }}
                        placeholder="Material Name"
                        value={item.materialName}
                        // value={
                        //   ascpartName?.trim() ? ascpartName : item.materialName
                        // }
                        onChange={(e) => {
                          // let list = [...stockReorderData];
                          // list[index]["materialName"] = e.target.value;

                          // let mate_length = list[index]["materialName"].length;
                          // let min_length = list[index]["min"].length;
                          // let supp_length = list[index]["supplier"].length;
                          handleOnChange(index, "materialName", e.target.value);

                          // setTypeInScreen("asc");
                        }}
                      />
                    </div>

                    <div className="asc-input-container mt-3" id="ascInput">
                      <label className="asc-label-top ClientNameText">
                        Min
                      </label>
                      <input
                        type="number"
                        min={0}
                        // disabled
                        className="asc_NormalInput ps-3 pointerEven-t"
                        style={{
                          width: "60px",
                          color: "#323232",
                          fontWeight: "600",
                        }}
                        placeholder="Min"
                        value={item.min}
                        onChange={(e) => {
                          handleOnChange(index, "min", e.target.value);
                        }}
                      />
                    </div>

                    <div
                      className="asc-input-container mt-3"
                      id="ascInput"
                      ref={supplierPopupRef}
                      style={{ position: "relative" }}
                    >
                      <label className="asc-label-top ClientNameText">
                        Supplier
                      </label>
                      <input
                        type="text"
                        // disabled
                        className="asc_NormalInput ps-4 pointerEven-t"
                        style={{
                          width: "310px",
                          color: "#323232",
                          fontWeight: "600",
                        }}
                        placeholder="Supplier"
                        value={item.supplier}
                        onChange={(e) => {
                          handleOnChange(index, "supplier", e.target.value);
                        }}
                        onFocus={() => {
                          setSupplierDataShow(true);
                        }}
                      />
                    </div>

                    {supplierDataShow && (
                      <div
                        className="products-and-parts-supplier-customSelect_Outer ps-2"
                        style={{
                          width: "310px",
                          height: "120px",
                          // right: "70px",
                          bottom: "10px",
                          left: "417px",
                        }}
                      >
                        {supplierData
                          .filter((supplierItem) =>
                            supplierItem.suppliername
                              ?.toLowerCase()
                              .includes(item.supplier)
                          )
                          .map((innerItem, index2) => {
                            return (
                              <div
                                key={innerItem.supplierid}
                                className="products-and-parts-pointer products-and-parts-dropdown-spacing"
                                onClick={() => {
                                  handleOnChange(
                                    index,
                                    "supplier",
                                    innerItem.suppliername
                                  );
                                  setSupplierDataShow(false);
                                }}
                                style={{
                                  backgroundColor:
                                    innerItem.suppliername === item.supplier
                                      ? "#F4F5F4"
                                      : "transparent",
                                }}
                              >
                                {innerItem.suppliername}
                              </div>
                            );
                          })}
                        {supplierData.length === 0 && (
                          <span className="noDataDisplay">
                            No data to display!
                          </span>
                        )}
                      </div>
                    )}

                    {stockReorderData.length !== 1 &&
                      item.materialName !== "" &&
                      item.min !== "" &&
                      item.supplier !== "" && (
                        <img
                          className="pt-4 pointer"
                          src={deleteIcon}
                          alt=""
                          onClick={() => {
                            let data = [...stockReorderData];
                            data.splice(index, 1);
                            setStockReorderData(data);
                          }}
                        />
                      )}
                  </div>
                );
              })}

              <div className="py-5 d-flex justify-content-end gap-3 pe-4">
                <button
                  type="button"
                  className="mb-0 cancelBtn"
                  onClick={() => {
                    // if (typeInScreen !== "") {
                    //   setCancelPopupShow(true);
                    // } else {
                    //   history.goBack();
                    //   // history.push("/InvoiceAllList");
                    // }
                    setReorderPopup(false);
                  }}
                >
                  Cancel
                </button>

                <button
                  className="mb-0 makeInvoBtn"
                  onClick={() => {
                    // setInvoiceStatus("Not Sent");
                    // handleMakeInvoiceAdd("Not Sent");
                    // setTimeout(() => {
                    //   history.goBack();
                    // }, 3000);
                  }}
                >
                  Make
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </popupSection>
    </>
  );
}

export default PartsList;
